/* eslint-disable @nx/enforce-module-boundaries */
import { forwardRef, useContext, useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { PostBoxContext } from '../context';
import {
  Avatar,
  AvatarGroup,
  Box,
  Circle,
  Flex,
  HStack,
  Spinner,
  Text,
} from '@mybridge/ui';
import { ChatOutLined, CloseIcon, HandShakeSimpleIcon, SimpleCloseIcon, SuggestedPostIcon, FollowIcon, FollowingIconV2 } from '@mybridge/icons';
import {
  HandShakeIcon,
  CommentsIcon,
  PinnedIcon,
  SuggestedIcon,
  RepostedIcon,
  QuotedIcon,
} from '@mybridge/icons/DashboardNewICons';

import { ShareIcon } from '@mybridge/icons/Share';
import { getUserFullName, getUserProfilePic } from 'v4/lib/commons';
import Link from 'next/link';
import { MyNetworkContext } from 'v4/components/network/context';
import { InsightPopover } from '../insight-popover';
import _ from 'lodash';
import { Divider, IconButton, Tab, TabList, TabPanel, TabPanels, Tabs, Tooltip, useDisclosure, VStack } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { GlobalMatrixPopup } from 'v4/snippets/globalMatrixPopup';
import { getMatrixUserId, getNextPageFromURL, flattenQueryResults, getRoomIdFromLS } from 'v4/utils/utils';
import { getPostActivityUsers } from 'v4/store/actions/post.actions';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
export const PostActivityHeader = forwardRef(
  ({ maxUserCount = 3, maxCount = 15, post, ...props }, ref) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedUser, setSelectedUser] = useState(null);
    const [confirmAction, setConfirmAction] = useState(() => () => undefined);
    const { post: ps } = useContext(PostBoxContext);
    const router = useRouter()
    const { t } = useTranslator();
    const direction = useDirection();
    const { myFirstDegreeConnections, 
      refetchMyFirstDegreeConnections,
      isFriend,
      handshakeUser,
      followUser,
      unfollowUser,
      isHandshakeRequested,
      isFollowed,
      handshakeLoading,
      followLoading,
      unfollowLoading,
      handleHandshakeSendRevoke, 
    } = useContext(MyNetworkContext);

      const dispatch = useDispatch();
      const [currentActivityType, setCurrentActivityType] = useState(null);
      const [selectedTabIndex, setSelectedTabIndex] = useState(0);
      const scrollContainerRef = useRef(null);

      const [loadingButtonId, setLoadingButtonId] = useState(null);

      // Modify the handshake handler
      const handleHandshake = async (user) => {
        setLoadingButtonId(user.id);
        try {
          await handshakeUser?.(user);
        } finally {
          setLoadingButtonId(null);
        }
      };

      // Handle follow/unfollow for companies
      const handleFollowUnfollow = async (user) => {
        setLoadingButtonId(user.id);
        try {
          if (isFollowed?.(user)) {
            await unfollowUser?.(user);
          } else {
            await followUser?.(user);
          }
        } finally {
          setLoadingButtonId(null);
        }
      };
      
    const currentUserInfo = useSelector(state=> state?.userProfile?.userProfileInfo);
    // const side = typeof window !== 'undefined' ? document.documentElement.dir : 'ltr';
    const [side, setSide] = useState('ltr');
    
    useEffect(() => {
      if (typeof window !== 'undefined') {
        setSide(document.documentElement.dir);
      }
    }, []);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const { pinned } = props;
    const {
      comment_count,
      repost,
      like_count,
      dislike_count,
      liked_by,
      dislike_by,
      reposts_by,
      comment_by,
    } = ps ?? {};

    // const likedBy = liked_by
    //   ?.filter?.((_, ind) => ind < maxCount)
    //   ?.map?.((lb, i) => <Box key={i}>{getUserFullName(lb)}</Box>);
    // if (liked_by?.length > maxCount) {
    //   likedBy.push(<Box>{t('scheduling.and') || "and"} {liked_by?.length - maxCount} {t('otherModules.more') || "more"}</Box>);
    // }
    // const dislikedBy = dislike_by
    //   ?.filter?.((_, ind) => ind < maxCount)
    //   ?.map?.((lb, i) => <Box key={i}>{getUserFullName(lb)}</Box>);
    // if (dislike_by?.length > maxCount) {
    //   dislikedBy.push(<Box>{t('scheduling.and') || "and"} {dislike_by?.length - maxCount} {t('otherModules.more') || "more"}</Box>);
    // }
    // const repostBy = _.uniqBy(reposts_by ?? [], (e) => e.id)
    //   ?.filter?.((_, ind) => ind < maxCount)
    //   .map?.((lb, i) => <Box key={i}>{getUserFullName(lb)}</Box>);
    // if (reposts_by?.length > maxCount) {
    //   repostBy.push(<Box>{t('scheduling.and') || "and"} {reposts_by?.length - maxCount} {t('otherModules.more') || "more"}</Box>);
    // }

    // const commentBy = comment_by
    //   ?.filter?.((_, ind) => ind < maxCount)
    //   ?.map?.((lb, i) => <Box key={i}>{getUserFullName(lb)}</Box>);
    // if (comment_by?.length > maxCount) {
    //   commentBy.push(<Box>{t('scheduling.and') || "and"} {comment_by?.length - maxCount} {t('otherModules.more') || "more"}</Box>);
    // }

    // const sharedBy = reposts_by
    //   ?.filter?.((_, ind) => ind < maxCount)
    //   ?.map?.((lb, i) => <Box key={i}>{getUserFullName(lb)}</Box>);
    // if (reposts_by?.length > maxCount) {
    //   sharedBy.push(<Box>{t('scheduling.and') || "and"} {reposts_by?.length - maxCount} {t('otherModules.more') || "more"}</Box>);
    // }

    const map = useMemo(() => {
      const post_ = post ?? ps ?? {};
      return [
        {
          append: t('post.quotedPost') || 'Quoted post',
          icon: <QuotedIcon color="#5B5B5B" />,
          count:
            // post_.repost !== null && post_.content && post_.content !== ''
            //   ? Infinity
            //   : -Infinity,
            post_?.quoted_share_count || 0,
          // users: post_?.author,
          users: post_?.reposts_by,
          extra: Math.max((post_?.comment_by?.length ?? 0) - maxUserCount, 0),
          // content: commentBy,
        },
        {
          // append: `${post_.comment_count >10 ? "+" + post_.comment_count/10 : "+" + post_.comment_count } Commented`,
          // append: `${post_.comment_count > 3 ? "+" + post_.comment_count - 3 : '' } Commented`,
          append: t('post.commented') || 'Commented',
          icon: <CommentsIcon color="#5B5B5B" />,
          count: post_?.comment_count || 0,
          users: post_?.comment_by,
          extra: Math.max((post_?.comment_by?.length ?? 0) - maxUserCount, 0),
          // content: commentBy,
        },
        {
          // append: `${post_.like_count >10 ? "+" + post_.like_count/10 : "+" + post_.like_count } Agreed`,
          append: t('post.agreed') || 'Agreed',
          icon: <HandShakeIcon color="#037F29" />,
          count: post_?.like_count || 0,
          users: post_?.liked_by,
          extra: Math.max((post_?.liked_by?.length ?? 0) - maxUserCount, 0),
          // content: likedBy,
        },
        {
          // append: `${post_.dislike_count >10 ? "+" + post_.dislike_count/10 : "+" + post_.dislike_count } Disagreed`,
          append: t('post.disagreed') || 'Disagreed',
          icon: <HandShakeIcon color="#E41C19" />,
          count: post_?.dislike_count || 0,
          users: post_?.dislike_by,
          extra: Math.max((post_?.dislike_by?.length ?? 0) - maxUserCount, 0),
          // content: dislikedBy,
        },
        {
          // append: `${post_.share_count >10 ? "+" + post_.share_count/10 : "+" + post_.share_count } Reposted`,
          append: t('post.reposted') || 'Reposted',
          icon: <RepostedIcon color="#5B5B5B" />,
          count: post_?.share_count || 0,
          users: post_?.reposts_by,
          extra: Math.max((post_?.reposts_by?.length ?? 0) - maxUserCount, 0),
          // content: sharedBy,
        },
      ];
    }, [post, ps, maxUserCount, t]);

    // Map activity type to API type
    const getActivityApiType = useCallback((activityAppend) => {
      const activityMap = {
        [t('post.agreed') || 'Agreed']: 'liked_by',
        [t('post.disagreed') || 'Disagreed']: 'disliked_by',
        [t('post.commented') || 'Commented']: 'commented_by',
        [t('post.reposted') || 'Reposted']: 'shared_by',
        [t('post.quotedPost') || 'Quoted post']: 'shared_by',
      };
      return activityMap[activityAppend] || 'all';
    }, [t]);
    
    const toShow = useMemo(
      () => map?.sort?.((a, b) => b.count - a.count)?.[0],
      [map]
    );

    // Get current activity type for API
    const apiActivityType = useMemo(() => {
      return currentActivityType || getActivityApiType(toShow?.append);
    }, [currentActivityType, toShow?.append, getActivityApiType]);

    // Check if we need to fetch both agreed and disagreed data
    const shouldFetchBoth = useMemo(() => {
      const isAgreedDisagreed = toShow?.append === (t('post.agreed') || 'Agreed') || 
                                toShow?.append === (t('post.disagreed') || 'Disagreed');
      return isAgreedDisagreed && (currentActivityType === 'all' || !currentActivityType);
    }, [toShow?.append, currentActivityType, t]);

    // Query for liked_by (Agreed)
    const {
      data: likedByQueryData,
      isLoading: loadingLikedBy,
      isFetching: loadingMoreLikedBy,
      fetchNextPage: fetchNextPageLikedBy,
      hasNextPage: hasNextPageLikedBy,
    } = useInfiniteQuery({
      queryKey: ['post-activity-users', ps?.id, 'liked_by'],
      queryFn: async ({ pageParam = 1 }) => {
        if (!ps?.id) return { results: [], next: null, count: 0 };
        const res = await dispatch(getPostActivityUsers({ 
          id: ps?.id, 
          type: 'liked_by', 
          page: pageParam 
        }));
        return res?.payload || { results: [], next: null, count: 0 };
      },
      getNextPageParam: (lastPage) => getNextPageFromURL(lastPage?.next),
      refetchOnWindowFocus: false,
      enabled: isPopupOpen && !!ps?.id && (shouldFetchBoth || apiActivityType === 'liked_by'),
    });

    // Query for disliked_by (Disagreed)
    const {
      data: dislikedByQueryData,
      isLoading: loadingDislikedBy,
      isFetching: loadingMoreDislikedBy,
      fetchNextPage: fetchNextPageDislikedBy,
      hasNextPage: hasNextPageDislikedBy,
    } = useInfiniteQuery({
      queryKey: ['post-activity-users', ps?.id, 'disliked_by'],
      queryFn: async ({ pageParam = 1 }) => {
        if (!ps?.id) return { results: [], next: null, count: 0 };
        const res = await dispatch(getPostActivityUsers({ 
          id: ps?.id, 
          type: 'disliked_by', 
          page: pageParam 
        }));
        return res?.payload || { results: [], next: null, count: 0 };
      },
      getNextPageParam: (lastPage) => getNextPageFromURL(lastPage?.next),
      refetchOnWindowFocus: false,
      enabled: isPopupOpen && !!ps?.id && (shouldFetchBoth || apiActivityType === 'disliked_by'),
    });

    // Query for other activity types (commented, reposted, etc.)
    const {
      data: postUsersQueryData,
      isLoading: loadingUsers,
      isFetching: loadingMore,
      fetchNextPage,
      hasNextPage,
      refetch: refetchPostUsers,
    } = useInfiniteQuery({
      queryKey: ['post-activity-users', ps?.id, apiActivityType],
      queryFn: async ({ pageParam = 1 }) => {
        if (!ps?.id) return { results: [], next: null, count: 0 };
        const res = await dispatch(getPostActivityUsers({ 
          id: ps?.id, 
          type: apiActivityType, 
          page: pageParam 
        }));
        return res?.payload || { results: [], next: null, count: 0 };
      },
      getNextPageParam: (lastPage) => getNextPageFromURL(lastPage?.next),
      refetchOnWindowFocus: false,
      enabled: isPopupOpen && !!ps?.id && !!apiActivityType && !shouldFetchBoth && apiActivityType !== 'liked_by' && apiActivityType !== 'disliked_by',
    });

    // Flatten query results
    const likedByData = useMemo(() => {
      return flattenQueryResults(likedByQueryData || { pages: [] });
    }, [likedByQueryData]);

    const dislikedByData = useMemo(() => {
      return flattenQueryResults(dislikedByQueryData || { pages: [] });
    }, [dislikedByQueryData]);

    // Combine liked_by and disliked_by data for "All" tab
    const combinedAllData = useMemo(() => {
      if (currentActivityType === 'all' || (!currentActivityType && shouldFetchBoth)) {
        return [...(likedByData || []), ...(dislikedByData || [])];
      }
      return [];
    }, [likedByData, dislikedByData, currentActivityType, shouldFetchBoth]);

    // Flatten and combine query results for other activity types
    const postUsersData = useMemo(() => {
      if (shouldFetchBoth) {
        // For agreed/disagreed, return appropriate data based on currentActivityType
        if (currentActivityType === 'all' || !currentActivityType) {
          return combinedAllData;
        } else if (currentActivityType === 'liked_by') {
          return likedByData;
        } else if (currentActivityType === 'disliked_by') {
          return dislikedByData;
        }
      }
      return flattenQueryResults(postUsersQueryData || { pages: [] });
    }, [postUsersQueryData, shouldFetchBoth, currentActivityType, combinedAllData, likedByData, dislikedByData]);

    // Combined loading states
    const isLoadingUsers = shouldFetchBoth 
      ? (currentActivityType === 'all' || !currentActivityType 
          ? (loadingLikedBy || loadingDislikedBy)
          : currentActivityType === 'liked_by' 
            ? loadingLikedBy 
            : loadingDislikedBy)
      : loadingUsers;
    
    const isLoadingMore = shouldFetchBoth
      ? (currentActivityType === 'all' || !currentActivityType
          ? (loadingMoreLikedBy || loadingMoreDislikedBy)
          : currentActivityType === 'liked_by'
            ? loadingMoreLikedBy
            : loadingMoreDislikedBy)
      : loadingMore;

    // Handle scroll for infinite scroll
    const handleScroll = (e) => {
      const container = e.target;
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      
      // Load more when 80% scrolled
      if (scrollTop + clientHeight >= scrollHeight * 0.8 && !isLoadingMore) {
        if (shouldFetchBoth && (currentActivityType === 'all' || !currentActivityType)) {
          // Fetch more from both queries if either has more pages
          if (hasNextPageLikedBy) {
            fetchNextPageLikedBy();
          }
          if (hasNextPageDislikedBy) {
            fetchNextPageDislikedBy();
          }
        } else if (shouldFetchBoth && currentActivityType === 'liked_by') {
          if (hasNextPageLikedBy) {
            fetchNextPageLikedBy();
          }
        } else if (shouldFetchBoth && currentActivityType === 'disliked_by') {
          if (hasNextPageDislikedBy) {
            fetchNextPageDislikedBy();
          }
        } else if (hasNextPage) {
          fetchNextPage();
        }
      }
    };
    
    const showSuggested = useMemo(
      () => (map?.find?.((i) => i.count > 0) ? false : ps?.suggested),
      [map]
    );

    // const users = useMemo(() => {
    //   if (myFirstDegreeConnections?.length) {
    //     return toShow?.users
    //       ?.map?.((u) => ({
    //         ...(u ?? {}),
    //         order: myFirstDegreeConnections?.find?.((u_) => u_?.id === u?.id)
    //           ?.id
    //           ? 0
    //           : 1,
    //       }))
    //       ?.sort((a, b) => a - b);
    //   }
    //   return toShow?.users ?? [];
    // }, [toShow?.users, myFirstDegreeConnections]);
    // Modify the users array to deduplicate by user ID
    const users = useMemo(() => {
      if (myFirstDegreeConnections?.length) {
        return _.uniqBy(
          toShow?.users
            ?.map?.((u) => ({
              ...(u ?? {}),
              order: myFirstDegreeConnections?.find?.((u_) => u_?.id === u?.id)
                ?.id
                ? 0
                : 1,
            }))
            ?.sort((a, b) => a - b),
          'id'  // Deduplicate by ID
        );
      }
      return _.uniqBy(toShow?.users ?? [], 'id');
    }, [toShow?.users, myFirstDegreeConnections]);

    

    // const agreedUsers = map.find(item => item?.append === (t('post.agreed') || 'Agreed'))?.users ?? [];
    // const disagreedUsers = map.find(item => item?.append === (t('post.disagreed') || 'Disagreed'))?.users ?? [];
    // const allCount = liked_by?.length + dislike_by?.length;
    // const agreedCount = agreedUsers?.length;
    // const disagreedCount = disagreedUsers?.length;
    // const AllUsers = [...(liked_by || []), ...(dislike_by || [])];


    const agreedUsers = likedByData && likedByData.length > 0 ? likedByData : (liked_by || []);
    const disagreedUsers = dislikedByData && dislikedByData.length > 0 ? dislikedByData : (dislike_by || []);
    const allCount = like_count+dislike_count;
    const agreedCount = like_count;
    const disagreedCount = dislike_count;
    const AllUsers = [...(likedByData || liked_by || []), ...(dislikedByData || dislike_by || [])];

    useEffect(() => {
      if (!myFirstDegreeConnections || myFirstDegreeConnections?.length <= 0) {
        refetchMyFirstDegreeConnections?.();
      }
    }, []);

    const timerRef = useRef(null);
    // console.log(comment_by);

    const triggerRef = useRef(null);

    // Function to calculate position
    const getPopupPosition = () => {
      if (!triggerRef.current) return {};
      
      const triggerRect = triggerRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const spaceBelow = viewportHeight - triggerRect.bottom;
      const spaceAbove = triggerRect.top;
      
      // If more space below, show popup below
      if (spaceBelow >= 400 || spaceBelow > spaceAbove) {
        return {
          top: triggerRect.bottom + 8,
          left: triggerRect.left
        };
      }
      
      // Show popup above if more space there
      return {
        bottom: viewportHeight - triggerRect.top + 8,
        left: triggerRect.left
      };
    };

    if (pinned) {
      return (
        <HStack py={3} px={4} >
          {/* <Box
            display="flex"
            bg="#E4E6EB"
            w="28px"
            h="28px"
            justifyContent="center"
            boxShadow="2px 0px 6px 0px #00000033"
            alignItems="center"
            borderRadius="full"
          >
              <PindIcon color="rgba(0,0,0,0.3)" width="16" height="16" />
          </Box> */}
          <Circle
            bg="#D9D9D9"
            w="28px"
            h="28px"
            boxShadow="0px -5px 3p<MenuButton
            as={IconButton}
            icon={<HorizontalThreeDot />}
            sx={{
              borderRadius: '27px ',
              border: '1px solid #00000033',
              backgroundColor: 'transparent',
              color: 'inherit',
              _hover: {
                backgroundColor: 'white',
                color: 'inherit',
              },
              _focus: {
                backgroundColor: 'white',
                color: 'inherit',
              },
            }}
            onClick={(e) => {
              e.stopPropagation?.();
            }}
          >
            {children}
          </MenuButton>x 0px #00000008 inset, 0px 4px 5px 0px #0000000F inset, 0px 0px 10px 0px #00000029"
          >
            <PinnedIcon />
          </Circle>

          <HStack spacing={1}>
            <Text fontSize="sm" color="#828282">
              {t('post.pinned') || 'Pinned'}
            </Text>
          </HStack>
        </HStack>
      );
    }

    if (toShow.count <= 0) {
      return <></>;
    }

    

    const handleClick = () => {
      if (isPopupOpen) {
        handleMouseLeave();
      } else {
        // If it's Agreed/Disagreed, start with 'all' to show combined data in All tab
        // Otherwise use the activity type
        const apiType = getActivityApiType(toShow?.append);
        const initialType = (apiType === 'liked_by' || apiType === 'disliked_by') ? 'all' : apiType;
        setCurrentActivityType(initialType);
        setIsPopupOpen(true);
      }
    };

    const handleMouseLeave = () => {
      // timerRef.current = setTimeout(() => {
        setIsPopupOpen(false);
      // }, 1000);
    };

    return (
      <>
        {showSuggested ? (
          <HStack p={4}>
            {/* <Box display="flex"
              bg="#E4E6EB"
              w="28px"
              h="28px"
              justifyContent="center"
              boxShadow="2px 0px 6px 0px #00000033"
              alignItems="center"
              borderRadius="full">
              <SuggestedPostIcon />
            </Box> */}
            <Circle
              bg="#D9D9D9"
              w="28px"
              h="28px"
              boxShadow="0px -5px 3px 0px #00000008 inset, 0px 4px 5px 0px #0000000F inset, 0px 0px 10px 0px #00000029"
            >
              <SuggestedIcon />
            </Circle>
            <Text>{t('post.suggested') || 'Suggested for you'}</Text>
          </HStack>
        ) : (
          <HStack py={3} px={4}>
            {/* <InsightPopover content={commentBy}> */}
            <Circle
              bg="#D9D9D9"
              w="27px"
              h="26px"
              boxShadow="0px -5px 3px 0px #00000008 inset, 0px 4px 5px 0px #0000000F inset, 0px 0px 10px 0px #00000029"
            >
              {toShow.icon}
            </Circle>
            <HStack 
              ref={triggerRef}
              spacing={1}
              alignItems="center"
              cursor="pointer"
              onClick={handleClick}
            >
              <AvatarGroup color="#828282" size="sm" gap={'6px'} max={maxUserCount}>
                {users?.slice(0, maxUserCount)?.map?.((u, uInd) => (
                  <Avatar
                    as={Link}
                    href={
                      u?.name?.length > 0 ? '/c/' + u?.slug : '/p/' + u?.slug
                    }
                    key={u.id}
                    size="sm"
                    fontSize="10px"
                    src={u?.name?.length > 0 ? u?.image : getUserProfilePic(u)}
                    name={u?.name?.length > 0 ? u?.name : getUserFullName(u)}
                  />
                ))}
              </AvatarGroup>
              {/* {console.log(toShow?.count, maxUserCount,toShow?.count - maxUserCount, 'connnedmjf' )} */}
              {toShow?.count > maxUserCount && <Text fontSize="14px" fontWeight={500} mx="4px" mb="2px" color="#828282">
                {(`${(toShow?.count - maxUserCount) > 0 ? '+' + (toShow?.count - maxUserCount) : ''}`) ?? 0}
              </Text>}
              <Text fontSize="16px" color="#828282">
                {toShow.append}
              </Text>
            </HStack>
            {/* </InsightPopover> */}
          </HStack>
        )}
        {isPopupOpen && (
          <Box
          overscroll={"contain"}
          position="fixed"
          w={["350px","400px"]}
          bg="white"
          {...(direction === 'rtl') && {left: '900px !important'}}
          borderRadius="8px"
          boxShadow = "0px 0px 10px 0px #00000033"
          p={4}
          pt={0}
          zIndex={10}
          style={getPopupPosition()}
          onMouseEnter={() => clearTimeout(timerRef.current)}
          onMouseLeave={handleMouseLeave}
          >
            
            <Box position="relative" border="transparent">
            {(toShow?.append === (t('post.agreed') || 'Agreed') || toShow?.append === (t('post.disagreed') || 'Disagreed')) && <IconButton
              pos={"absolute"}
              {...(side === 'rtl') ? {left: '0'} : {right: '0'}}
              top={"21px"}
              icon={<SimpleCloseIcon height="14px" width="14px" />}
              aria-label="Close"
              variant={'unstyled'}
              onClick={() => setIsPopupOpen(false)}
            />}
            <Divider mb={4} />
            {isLoadingUsers ? (
              <Box p={4} textAlign="center">
                <Spinner/>
              </Box>
            ) : toShow?.append === (t('post.agreed') || 'Agreed') || toShow?.append === (t('post.disagreed') || 'Disagreed') ? 
            <Tabs 
              border={"transparent"} 
              index={selectedTabIndex}
              onChange={(index) => {
                const types = ['all', 'liked_by', 'disliked_by'];
                setCurrentActivityType(types[index]); //(changing query will auto-refetch)
                setSelectedTabIndex(index);
              }}
            >
              <TabList>
                <Tab color={"#3D5A80"} fontWeight={400} fontSize={"15px"}>{`${t('publicProfile.all') || "All"} ${(agreedCount+disagreedCount || postUsersData?.length || allCount)}`}</Tab>
                {/* {agreedCount > 0 && <Tab color={"#3D5A80"} fontWeight={400} fontSize={"15px"}><HandShakeIcon color="#037F29" /><Text mx="5px">{ agreedCount }</Text></Tab>} */}
                {agreedCount > 0 && <Tab color={"#3D5A80"} fontWeight={400} fontSize={"15px"} alignItems="center"><HandShakeIcon color="#037F29" /><Text mx="5px">{ agreedCount }</Text></Tab>}
                {/* {disagreedCount > 0 && <Tab color={"#3D5A80"} fontWeight={400} fontSize={"15px"}><HandShakeIcon color="#E41C19" /><Text mx="5px">{ disagreedCount }</Text></Tab>} */}
                {disagreedCount > 0 && <Tab color={"#3D5A80"} fontWeight={400} fontSize={"15px"} alignItems="center"><HandShakeIcon color="#E41C19" /><Text mx="5px">{ disagreedCount }</Text></Tab>}
              </TabList>
              <TabPanels maxHeight="300px" overflowY="auto" onScroll={handleScroll} ref={scrollContainerRef} overscroll={"contain"}>
                {/* All Users */}
                <TabPanel>
                  <VStack spacing={4} align="stretch">
                    {(postUsersData && postUsersData.length > 0 ? postUsersData : AllUsers).map((user, index) => {
                      const isCompanyAuthor = user?.author_type === 'COMPANY';
                      const companyData = isCompanyAuthor ? user?.company_detail : null;

                      const isCompany = isCompanyAuthor ? !!companyData : (user?.name?.length > 0);
                      const displayImage = isCompanyAuthor
                        ? (companyData?.image || user?.profile_pic)
                        : (user?.name?.length > 0 ? user?.image : user?.profile_pic);
                      const displayName = isCompanyAuthor
                        ? (companyData?.name || getUserFullName(user))
                        : (user?.name?.length > 0 ? user?.name : getUserFullName(user));
                      const displaySlug = isCompanyAuthor
                        ? (companyData?.slug || user?.slug)
                        : user?.slug;
                      const companyOwnedByCurrentUser = isCompanyAuthor
                        ? (user?.id === currentUserInfo?.id)
                        : (user?.user === currentUserInfo?.id);

                      return (
                      <Flex key={`all-${user?.id}-${index}`} alignItems="center" justifyContent="space-between">
                        <HStack spacing={3} cursor="pointer" onClick={() => {
                          if (isCompany) {
                            // It's a company
                            if (companyOwnedByCurrentUser) {
                              router.push(`/page/private/${isCompanyAuthor ? companyData?.id : user?.id}`);
                            } else {
                              router.push(`/c/${displaySlug}`);
                            }
                          } else {
                            // It's a user
                            if (currentUserInfo?.id === user?.id) {
                              router.push(`/profile/me`);
                            } else {
                              router.push(`/p/${user?.slug}`);
                            }
                          }
                        }}>
                          <Box pos="relative">
                            <Avatar src={displayImage} name={displayName} />
                            <Box
                              pos="absolute"
                              bottom="0"
                              right="0"
                              borderRadius="full"
                              w="20px"
                              h="20px"
                              // background={toShow?.append === ' Agreed' ? "#037F29" : "#E41C19"}
                              background={
                                (currentActivityType === 'liked_by') || 
                                (likedByData && likedByData.some(likedUser => likedUser.id === user.id))
                                  ? "#037F29"  // Green for Agreed users
                                  : "#E41C19"  // Red for Disagreed users
                              }
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              border="2px solid white"
                            >
                              <HandShakeSimpleIcon
                                color="#ffffff"
                                width="12"
                                height="12"
                              />
                            </Box>
                          </Box>
                          {/* <Avatar src={user?.profile_pic} name={getUserFullName(user)} /> */}
                          <Text fontWeight="500" color="#5B5B5B" fontSize="15px">{displayName}</Text>
                        </HStack>
                        <HStack spacing={2}>
                          {(currentUserInfo?.id === user?.id) ? null :
                          (isCompany) ? (
                            // Company: show follow button (hide if owned by current user)
                            companyOwnedByCurrentUser ? null : (
                              <Tooltip label={isFollowed?.(user) ? (t('publicProfile.following') || 'Following') : (t('publicProfile.follow') || 'Follow')}>
                                <IconButton
                                  onClick={(e) => handleFollowUnfollow(user)}
                                  _hover={{ bg: 'gray.100' }}
                                  isLoading={loadingButtonId === user.id && (followLoading || unfollowLoading)}
                                  w={'41px'}
                                  height={'41px'}
                                  border={'1px solid #00000033'}
                                  cursor="pointer"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius={'50%'}
                                  variant="none"
                                  icon={
                                    isFollowed?.(user) ? (
                                      <FollowingIconV2
                                        width="20"
                                        height="20"
                                      />
                                    ) : (
                                      <FollowIcon
                                        width="20"
                                        height="20"
                                      />
                                    )
                                  }
                                />
                              </Tooltip>
                            )
                          ) :
                          !isFriend(user) ? <HStack>
                            {isHandshakeRequested?.(user) ? (
                              <Tooltip label={t('publicProfile.withdrawHandshake') || "Withdraw Handshake"}>
                                <IconButton
                                  onClick={(e) =>
                                    handleHandshakeSendRevoke?.(user)
                                  }
                                  _hover={{ bg: 'gray.100' }}
                                  isLoading={handshakeLoading}
                                  // isDisabled={isHandshakeRequested?.(user)}
                                  
                                  icon={
                                    <HandShakeSimpleIcon
                                      color="#F5AEAD"
                                      width="20"
                                      height="20"
                                    />
                                  }
                                  w={'41px'}
                                  height={'41px'}
                                  border={'1px solid #00000033'}
                                  cursor="pointer"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius={'50%'}
                                  
                                  variant="none"
                                />

                              </Tooltip>
                            ) : (
                              <Tooltip zIndex="99999999" label={t('publicProfile.sendHandshakeRequest') || "Send Handshake Request"}>
                                <IconButton
                                  w={'41px'}
                                  _hover={{ bg: 'gray.100' }}
                                  height={'41px'}
                                  border={'1px solid #00000033'}
                                  cursor="pointer"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius={'50%'}
                                  variant="none"
                                  onClick={(e) => handleHandshake?.(user)}
                                  // isLoading={handshakeLoading }
                                  isLoading={loadingButtonId === user.id}
                                  // w="70px"
                                  // isDisabled={isHandshakeRequested?.(user)}
                                  icon={
                                    <HandShakeSimpleIcon
                                      color="#94B096"
                                      // color={
                                      //   liked_by.some(likedUser => likedUser.id === user.id)
                                      //     ? "#037F29"  // Green for Agreed users
                                      //     : "#E41C19"  // Red for Disagreed users
                                      // }
                                      width="20"
                                      height="20"
                                    />
                                  }
                                />
                              </Tooltip>
                            )}
                          </HStack> : 
                          <Box
                            w={'41px'}
                            height={'41px'}
                            border={'1px solid #00000033'}
                            cursor="pointer"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            borderRadius={'50%'}
                            // onClick={(e) => {
                            //   router.push(`/profile/message?user=${user?.matrix_user_id}`)
                            // }}
                            onClick={() => {
                              // const matrixUserId = getMatrixUserId(user?.id);

                              // if (!(user?.connection?.chat_room_id || matrixUserId)) {
                              //   setConfirmAction(() => (newId) => {
                              //     router.push(`/profile/message?user=${newId}`);
                              //   });
                              //   onOpen();
                              // } else {
                              //   router.push(`/profile/message?user=${user?.matrix_user_id || matrixUserId}`);
                              // }

                              const roomId = getRoomIdFromLS(user?.id);
                              router.push(`/profile/message?user=${roomId}`);
                            }}
                            _hover={{ bg: 'gray.100' }}
                          >
                            <ChatOutLined/>
                          </Box>
                          }
                        </HStack>
                      </Flex>
                      );
                    })}
                    {isLoadingMore && (
                      <Box p={4} textAlign="center">
                        <Spinner/>
                      </Box>
                    )}
                  </VStack>
                </TabPanel>
                {/* Agree Users */}
                {agreedCount > 0 && <TabPanel>
                  <VStack spacing={4} align="stretch">
                    {((currentActivityType === 'liked_by' && likedByData && likedByData.length > 0) ? likedByData : agreedUsers).map((user, index) => (
                        <Flex key={`liked-${user?.id}-${index}`} alignItems="center" justifyContent="space-between">
                          {/* <HStack spacing={3} cursor="pointer" onClick={() => currentUserInfo?.id === user?.id ? router.push(`/profile/me`) : router.push(`/p/${user?.slug}`)}>
                            <Avatar src={user?.profile_pic} name={getUserFullName(user)} />
                            <Text fontWeight="500" color="#5B5B5B" fontSize="15px">{getUserFullName(user)}</Text>
                          </HStack> */}
                          <HStack spacing={3} cursor="pointer" onClick={() => {
                            if (user?.name?.length > 0) {
                              // It's a company
                              if (user?.user === currentUserInfo?.id) {
                                router.push(`/page/private/${user?.id}`);
                              } else {
                                router.push(`/c/${user?.slug}`);
                              }
                            } else {
                              // It's a user
                              if (currentUserInfo?.id === user?.id) {
                                router.push(`/profile/me`);
                              } else {
                                router.push(`/p/${user?.slug}`);
                              }
                            }
                          }}>
                            <Avatar src={user?.name?.length > 0 ? user?.image : user?.profile_pic} name={user?.name?.length > 0 ? user?.name : getUserFullName(user)} />
                            <Text fontWeight="500" color="#5B5B5B" fontSize="15px">{user?.name?.length > 0 ? user?.name : getUserFullName(user)}</Text>
                          </HStack>
                          <HStack spacing={2}>
                          {/* <Circle
                            bg="#D9D9D9"
                            w="28px"
                            h="28px"
                            boxShadow="0px -5px 3px 0px #00000008 inset, 0px 4px 5px 0px #0000000F inset, 0px 0px 10px 0px #00000029"
                          >
                            <HandShakeIcon color="#037F29" />
                          </Circle> */}
                          {(currentUserInfo?.id === user?.id) ? null :
                          (user?.name?.length > 0) ? (
                            (user?.user === currentUserInfo?.id) ? null : (
                              <Tooltip label={isFollowed?.(user) ? (t('publicProfile.following') || 'Following') : (t('publicProfile.follow') || 'Follow')}>
                                <IconButton
                                  onClick={(e) => handleFollowUnfollow(user)}
                                  _hover={{ bg: 'gray.100' }}
                                  isLoading={loadingButtonId === user.id && (followLoading || unfollowLoading)}
                                  w={'41px'}
                                  height={'41px'}
                                  border={'1px solid #00000033'}
                                  cursor="pointer"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius={'50%'}
                                  variant="none"
                                  icon={
                                    isFollowed?.(user) ? (
                                      <FollowingIconV2
                                        width="20"
                                        height="20"
                                      />
                                    ) : (
                                      <FollowIcon
                                        width="20"
                                        height="20"
                                      />
                                    )
                                  }
                                />
                              </Tooltip>
                            )
                          ) :
                          !isFriend(user) ? <HStack>
                            {isHandshakeRequested?.(user) ? (
                              <Tooltip label={t('publicProfile.withdrawHandshake') || "Withdraw Handshake"}>
                                <IconButton
                                  onClick={(e) =>
                                    handleHandshakeSendRevoke?.(user)
                                  }
                                  _hover={{ bg: 'gray.100' }}
                                  isLoading={handshakeLoading}
                                  // isDisabled={isHandshakeRequested?.(user)}
                                  
                                  icon={
                                    <HandShakeSimpleIcon
                                      color="#F5AEAD"
                                      width="20"
                                      height="20"
                                    />
                                  }
                                  w={'41px'}
                                  height={'41px'}
                                  border={'1px solid #00000033'}
                                  cursor="pointer"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius={'50%'}
                                  
                                  variant="none"
                                />

                              </Tooltip>
                            ) : (
                              <Tooltip zIndex="99999999" label={t('publicProfile.sendHandshakeRequest') || "Send Handshake Request"}>
                                <IconButton
                                  w={'41px'}
                                  _hover={{ bg: 'gray.100' }}
                                  height={'41px'}
                                  border={'1px solid #00000033'}
                                  cursor="pointer"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius={'50%'}
                                  variant="none"
                                  onClick={(e) => handshakeUser?.(user)}
                                  isLoading={handshakeLoading}
                                  // w="70px"
                                  // isDisabled={isHandshakeRequested?.(user)}
                                  icon={
                                    <HandShakeSimpleIcon
                                      color="#94B096"
                                      width="20"
                                      height="20"
                                    />
                                  }
                                />
                              </Tooltip>
                            )}
                          </HStack>:
                          <Box
                          w={'41px'}
                          height={'41px'}
                          border={'1px solid #00000033'}
                          cursor="pointer"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          borderRadius={'50%'}
                          // onClick={(e) => {
                          //   router.push(`/profile/message?user=${user?.matrix_user_id}`)
                          // }}
                          onClick={() => {
                            // const matrixUserId = getMatrixUserId(user?.id);
                            
                            // if (!(user?.connection?.chat_room_id || matrixUserId)) {
                            //   setConfirmAction(() => (newId) => {
                            //     router.push(`/profile/message?user=${newId}`);
                            //   });
                            //   onOpen();
                            // } else {
                            //   router.push(`/profile/message?user=${user?.matrix_user_id || matrixUserId}`);
                            // }
                            const roomId = getRoomIdFromLS(user?.id);
                            router.push(`/profile/message?user=${roomId}`);
                          }}
                          _hover={{ bg: 'gray.100' }}
                        >
                          <ChatOutLined/>
                        </Box>
                          }
                          </HStack>
                        </Flex>
                      ))}
                  </VStack>
                </TabPanel>}
                {/* Disagree Users */}
                {disagreedCount > 0 && <TabPanel>
                  <VStack spacing={4} align="stretch">
                    {((currentActivityType === 'disliked_by' && dislikedByData && dislikedByData.length > 0) ? dislikedByData : disagreedUsers).map((user, index) => (
                        <Flex key={`disagreed-${user?.id}-${index}`} alignItems="center" justifyContent="space-between">
                          {/* <HStack spacing={3} cursor="pointer" onClick={() => currentUserInfo?.id === user?.id ? router.push(`/profile/me`) : router.push(`/p/${user?.slug}`)}>
                            <Avatar src={user?.profile_pic} name={getUserFullName(user)} />
                            <Text fontWeight="500" color="#5B5B5B" fontSize="15px">{getUserFullName(user)}</Text>
                          </HStack> */}
                          <HStack spacing={3} cursor="pointer" onClick={() => {
                            if (user?.name?.length > 0) {
                              // It's a company
                              if (user?.user === currentUserInfo?.id) {
                                router.push(`/page/private/${user?.id}`);
                              } else {
                                router.push(`/c/${user?.slug}`);
                              }
                            } else {
                              // It's a user
                              if (currentUserInfo?.id === user?.id) {
                                router.push(`/profile/me`);
                              } else {
                                router.push(`/p/${user?.slug}`);
                              }
                            }
                          }}>
                            <Avatar src={user?.name?.length > 0 ? user?.image : user?.profile_pic} name={user?.name?.length > 0 ? user?.name : getUserFullName(user)} />
                            <Text fontWeight="500" color="#5B5B5B" fontSize="15px">{user?.name?.length > 0 ? user?.name : getUserFullName(user)}</Text>
                          </HStack>
                          <HStack spacing={2}>
                          {(currentUserInfo?.id === user?.id) ? null :
                          (user?.name?.length > 0) ? (
                            (user?.user === currentUserInfo?.id) ? null : (
                              <Tooltip label={isFollowed?.(user) ? (t('publicProfile.following') || 'Following') : (t('publicProfile.follow') || 'Follow')}>
                                <IconButton
                                  onClick={(e) => handleFollowUnfollow(user)}
                                  _hover={{ bg: 'gray.100' }}
                                  isLoading={loadingButtonId === user.id && (followLoading || unfollowLoading)}
                                  w={'41px'}
                                  height={'41px'}
                                  border={'1px solid #00000033'}
                                  cursor="pointer"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius={'50%'}
                                  variant="none"
                                  icon={
                                    isFollowed?.(user) ? (
                                      <FollowingIconV2
                                        width="20"
                                        height="20"
                                      />
                                    ) : (
                                      <FollowIcon
                                        width="20"
                                        height="20"
                                      />
                                    )
                                  }
                                />
                              </Tooltip>
                            )
                          ) :
                          !isFriend(user) ? <HStack>
                            {isHandshakeRequested?.(user) ? (
                              <Tooltip label={t('publicProfile.withdrawHandshake') || "Withdraw Handshake"}>
                                <IconButton
                                  onClick={(e) =>
                                    handleHandshakeSendRevoke?.(user)
                                  }
                                  _hover={{ bg: 'gray.100' }}
                                  isLoading={handshakeLoading}
                                  // isDisabled={isHandshakeRequested?.(user)}
                                  
                                  icon={
                                    <HandShakeSimpleIcon
                                      color="#F5AEAD"
                                      width="20"
                                      height="20"
                                    />
                                  }
                                  w={'41px'}
                                  height={'41px'}
                                  border={'1px solid #00000033'}
                                  cursor="pointer"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius={'50%'}
                                  
                                  variant="none"
                                />

                              </Tooltip>
                            ) : (
                              <Tooltip zIndex="99999999" label={t('publicProfile.sendHandshakeRequest') || "Send Handshake Request"}>
                                <IconButton
                                  w={'41px'}
                                  _hover={{ bg: 'gray.100' }}
                                  height={'41px'}
                                  border={'1px solid #00000033'}
                                  cursor="pointer"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius={'50%'}
                                  variant="none"
                                  onClick={(e) => handshakeUser?.(user)}
                                  isLoading={handshakeLoading}
                                  // w="70px"
                                  // isDisabled={isHandshakeRequested?.(user)}
                                  icon={
                                    <HandShakeSimpleIcon
                                      color="#94B096"
                                      width="20"
                                      height="20"
                                    />
                                  }
                                />
                              </Tooltip>
                            )}
                          </HStack> :
                          <Box
                          w={'41px'}
                          height={'41px'}
                          border={'1px solid #00000033'}
                          cursor="pointer"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          borderRadius={'50%'}
                          // onClick={(e) => {
                          //   router.push(`/profile/message?user=${user?.matrix_user_id}`)
                          // }}
                          onClick={() => {
                            // const matrixUserId = getMatrixUserId(user?.id);
                            
                            // if (!(user?.connection?.chat_room_id || matrixUserId)) {
                            //   setConfirmAction(() => (newId) => {
                            //     router.push(`/profile/message?user=${newId}`);
                            //   });
                            //   onOpen();
                            // } else {
                            //   router.push(`/profile/message?user=${user?.matrix_user_id || matrixUserId}`);
                            // }
                            const roomId = getRoomIdFromLS(user?.id);
                            router.push(`/profile/message?user=${roomId}`);
                          }}
                          _hover={{ bg: 'gray.100' }}
                        >
                          <ChatOutLined/>
                        </Box>
                          }
                          </HStack>
                        </Flex>
                      ))}
                  </VStack>
                </TabPanel>}
              </TabPanels>
            </Tabs> : 
            <Box>
              <Flex justifyContent="space-between" alignItems="center" mb={4}>
                <Text fontWeight="400" fontSize="20px" color="#3D5A80" display="flex" justifyContent="center" width="100%">
                  {toShow?.append}
                </Text>
                <IconButton
                  display={"flex"}
                  icon={<SimpleCloseIcon height="14px" width="14px" />}
                  aria-label="Close"
                  variant={'unstyled'}
                  onClick={() => setIsPopupOpen(false)}
                />
              </Flex>
              <Box >
              <VStack spacing={4} align="stretch" maxH="300px" overflowY="auto" pr="10px" onScroll={handleScroll} ref={scrollContainerRef}>
                    {
                      (postUsersData && postUsersData.length > 0 ? postUsersData : _.uniqBy(toShow?.users || [], 'id')).map((user, index) => (
                        <Flex key={index} alignItems="center" justifyContent="space-between">
                          <HStack spacing={3} cursor="pointer" onClick={() => {
                            if (user?.name?.length > 0) {
                              // It's a company
                              if (user?.user === currentUserInfo?.id) {
                                router.push(`/page/private/${user?.id}`);
                              } else {
                                router.push(`/c/${user?.slug}`);
                              }
                            } else {
                              // It's a user
                              if (currentUserInfo?.id === user?.id) {
                                router.push(`/profile/me`);
                              } else {
                                router.push(`/p/${user?.slug}`);
                              }
                            }
                          }}>
                            <Avatar src={user?.name?.length > 0 ? user?.image : getUserProfilePic(user)} name={user?.name?.length > 0 ? user?.name : getUserFullName(user)} />
                            <Text fontWeight="500" color="#5B5B5B" fontSize="15px">{user?.name?.length > 0 ? user?.name : getUserFullName(user)}</Text>
                          </HStack>
                          <HStack spacing={2}>
                          {(currentUserInfo?.id === user?.id) ? null :
                          (user?.name?.length > 0) ? (
                            (user?.user === currentUserInfo?.id) ? null : (
                              <Tooltip label={isFollowed?.(user) ? (t('publicProfile.following') || 'Following') : (t('publicProfile.follow') || 'Follow')}>
                                <IconButton
                                  onClick={(e) => handleFollowUnfollow(user)}
                                  _hover={{ bg: 'gray.100' }}
                                  isLoading={loadingButtonId === user.id && (followLoading || unfollowLoading)}
                                  w={'41px'}
                                  height={'41px'}
                                  border={'1px solid #00000033'}
                                  cursor="pointer"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius={'50%'}
                                  variant="none"
                                  icon={
                                    isFollowed?.(user) ? (
                                      <FollowingIconV2
                                        width="20"
                                        height="20"
                                      />
                                    ) : (
                                      <FollowIcon
                                        width="20"
                                        height="20"
                                      />
                                    )
                                  }
                                />
                              </Tooltip>
                            )
                          ) :
                          !isFriend(user) ? <HStack>
                            {isHandshakeRequested?.(user) ? (
                              <Tooltip label={t('publicProfile.withdrawHandshake') || "Withdraw Handshake"}>
                                <IconButton
                                  onClick={(e) =>
                                    handleHandshakeSendRevoke?.(user)
                                  }
                                  _hover={{ bg: 'gray.100' }}
                                  isLoading={handshakeLoading}
                                  // isDisabled={isHandshakeRequested?.(user)}
                                  
                                  icon={
                                    <HandShakeSimpleIcon
                                      color="#F5AEAD"
                                      width="20"
                                      height="20"
                                    />
                                  }
                                  w={'41px'}
                                  height={'41px'}
                                  border={'1px solid #00000033'}
                                  cursor="pointer"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius={'50%'}
                                  
                                  variant="none"
                                />

                              </Tooltip>
                            ) : (
                              <Tooltip zIndex="99999999" label={t('publicProfile.sendHandshakeRequest') || "Send Handshake Request"}>
                                <IconButton
                                  w={'41px'}
                                  _hover={{ bg: 'gray.100' }}
                                  height={'41px'}
                                  border={'1px solid #00000033'}
                                  cursor="pointer"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius={'50%'}
                                  variant="none"
                                  onClick={(e) => handshakeUser?.(user)}
                                  isLoading={handshakeLoading}
                                  // w="70px"
                                  // isDisabled={isHandshakeRequested?.(user)}
                                  icon={
                                    <HandShakeSimpleIcon
                                      color="#94B096"
                                      width="20"
                                      height="20"
                                    />
                                  }
                                />
                              </Tooltip>
                            )}
                          </HStack> :
                          <Box
                          w={'41px'}
                          height={'41px'}
                          border={'1px solid #00000033'}
                          cursor="pointer"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          borderRadius={'50%'}
                          // onClick={(e) => {
                          //   router.push(`/profile/message?user=${user?.matrix_user_id}`)
                          // }}
                          onClick={() => {
                            // const matrixUserId = getMatrixUserId(user?.id) || user?.matrix_user_id;
                            // setSelectedUser(user);
                            
                            // if (!(user?.connection?.chat_room_id || matrixUserId)) {
                            //   setConfirmAction(() => (newId) => {
                            //     router.push(`/profile/message?user=${newId}`);
                            //   });
                            //   onOpen();
                            // } else {
                            //   router.push(`/profile/message?user=${user?.matrix_user_id || matrixUserId}`);
                            // }
                            const roomId = getRoomIdFromLS(user?.id);
                            router.push(`/profile/message?user=${roomId}`);
                          }}
                          _hover={{ bg: 'gray.100' }}
                        >
                          <ChatOutLined/>
                        </Box>
                          }
                          </HStack>
                        </Flex>
                      ))}
                    {isLoadingMore && (
                      <Box p={4} textAlign="center">
                        <Spinner/>
                      </Box>
                    )}
                  </VStack>
              </Box>
            </Box>
          
            }
            </Box>
          </Box>
        )}
        <GlobalMatrixPopup
          isOpen={isOpen}
          onClose={onClose}
          onConfirm={confirmAction}
          selectedUserId={selectedUser?.id}
        />
      </>
    );
  }
);
